/* eslint-disable */

/* This is auto generated code. Do not edit!!! */

import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDate: { input: string; output: string; }
  AWSDateTime: { input: string; output: string; }
  AWSEmail: { input: string; output: string; }
  AWSIPAddress: { input: string; output: string; }
  AWSJSON: { input: string; output: string; }
  AWSPhone: { input: string; output: string; }
  AWSTime: { input: string; output: string; }
  AWSTimestamp: { input: number; output: number; }
  AWSURL: { input: string; output: string; }
};

export const GraphQLCardExpiryStatus = {
  Expired: 'EXPIRED',
  ExpiringSoon: 'EXPIRING_SOON'
} as const;

export type GraphQLCardExpiryStatus = typeof GraphQLCardExpiryStatus[keyof typeof GraphQLCardExpiryStatus];
export type GraphQLCommitment = {
  __typename?: 'Commitment';
  _sys?: Maybe<GraphQLCommitmentSys>;
  commitmentType?: Maybe<GraphQLCommitmentType>;
  dates?: Maybe<GraphQLCommitmentDates>;
  fund?: Maybe<GraphQLCommitmentFund>;
  hasMissedPayment?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  internalId?: Maybe<Scalars['String']['output']>;
  interventionId?: Maybe<Scalars['String']['output']>;
  isCorrespondent?: Maybe<Scalars['Boolean']['output']>;
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
  lastCorrespondenceDate?: Maybe<Scalars['String']['output']>;
  participant?: Maybe<GraphQLCommitmentParticipant>;
  /** Last payment date in YYYY-MM-DD format (e.g., "2024-01-15") */
  paymentDateLast?: Maybe<Scalars['AWSDate']['output']>;
  /** Next payment date in YYYY-MM-DD format (e.g., "2024-01-15") */
  paymentDateNext?: Maybe<Scalars['AWSDate']['output']>;
  paymentFrequency?: Maybe<Scalars['String']['output']>;
  paymentMethodId?: Maybe<Scalars['String']['output']>;
  paymentPullDay?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  receiptorId?: Maybe<Scalars['String']['output']>;
  sourceCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type GraphQLCommitmentDates = {
  __typename?: 'CommitmentDates';
  end?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
};

export type GraphQLCommitmentFund = {
  __typename?: 'CommitmentFund';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
};

export type GraphQLCommitmentParticipant = {
  __typename?: 'CommitmentParticipant';
  birthdate?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  globalId?: Maybe<Scalars['String']['output']>;
  localId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  names?: Maybe<GraphQLCommitmentParticipantNames>;
  photoUrl?: Maybe<Scalars['String']['output']>;
};

export type GraphQLCommitmentParticipantNames = {
  __typename?: 'CommitmentParticipantNames';
  preferred?: Maybe<Scalars['String']['output']>;
};

export type GraphQLCommitmentSys = {
  __typename?: 'CommitmentSys';
  billingType?: Maybe<Scalars['String']['output']>;
  delinkType?: Maybe<Scalars['String']['output']>;
  linkType?: Maybe<Scalars['String']['output']>;
  program?: Maybe<Scalars['String']['output']>;
  recordType?: Maybe<Scalars['String']['output']>;
  subProgram?: Maybe<Scalars['String']['output']>;
};

export const GraphQLCommitmentType = {
  ChildSponsorship: 'ChildSponsorship',
  Correspondence: 'Correspondence',
  FundCommitment: 'FundCommitment',
  GiftCommitment: 'GiftCommitment',
  Intervention: 'Intervention',
  LivingSponsorship: 'LivingSponsorship',
  GiftCatalog: 'Non-Billing',
  NA: 'NA',
} as const;

export type GraphQLCommitmentType = typeof GraphQLCommitmentType[keyof typeof GraphQLCommitmentType];
export type GraphQLGivingTotals = {
  __typename?: 'GivingTotals';
  amountDue?: Maybe<Scalars['String']['output']>;
  amountWaived?: Maybe<Scalars['String']['output']>;
  annual?: Maybe<Scalars['String']['output']>;
  creditRemaining?: Maybe<Scalars['String']['output']>;
  monthly?: Maybe<Scalars['String']['output']>;
  quarterly?: Maybe<Scalars['String']['output']>;
  semiAnnual?: Maybe<Scalars['String']['output']>;
};

export type GraphQLPaymentMethodAch = {
  __typename?: 'PaymentMethodAch';
  accountName?: Maybe<Scalars['String']['output']>;
  lastFourOfAccountNumber?: Maybe<Scalars['String']['output']>;
  routingNumber?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type GraphQLPaymentMethodBillingAddress = {
  __typename?: 'PaymentMethodBillingAddress';
  attention?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type GraphQLPaymentMethodCreditCard = {
  __typename?: 'PaymentMethodCreditCard';
  cardType?: Maybe<Scalars['String']['output']>;
  cardholderName?: Maybe<Scalars['String']['output']>;
  digitalType?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  expiryStatus?: Maybe<GraphQLCardExpiryStatus>;
  lastFour?: Maybe<Scalars['String']['output']>;
  responseCode?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

/**
 * Currently all types live here.
 * Originally the idea was to maintain separate sub-schemas with a custom script to merge them,
 * but until things mature it seemed best to keep it all in one file.
 *
 * TOC
 *
 * = Operations
 * = Scalars
 * = Supporter
 * = Payment & Billing
 * = Commitment
 */
export type GraphQLQuery = {
  __typename?: 'Query';
  supporter?: Maybe<GraphQLSupporter>;
};


/**
 * Currently all types live here.
 * Originally the idea was to maintain separate sub-schemas with a custom script to merge them,
 * but until things mature it seemed best to keep it all in one file.
 *
 * TOC
 *
 * = Operations
 * = Scalars
 * = Supporter
 * = Payment & Billing
 * = Commitment
 */
export type GraphQLQuerySupporterArgs = {
  globalId?: InputMaybe<Scalars['String']['input']>;
};

export type GraphQLSupporter = {
  __typename?: 'Supporter';
  address?: Maybe<GraphQLSupporterAddress>;
  commitments?: Maybe<Array<Maybe<GraphQLCommitment>>>;
  /** The displayed name, based off preferred name or first/last name. */
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  givingTotals?: Maybe<GraphQLGivingTotals>;
  /** The Supporter's Global ID. */
  globalId?: Maybe<Scalars['String']['output']>;
  internalId?: Maybe<Scalars['String']['output']>;
  isGroup?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  names?: Maybe<GraphQLSupporterNames>;
  organization?: Maybe<Scalars['String']['output']>;
  paymentMethods?: Maybe<Array<Maybe<GraphQLSupporterPaymentMethod>>>;
  primaryContactId?: Maybe<Scalars['String']['output']>;
  specialHandling?: Maybe<GraphQLSupporterSpecialHandling>;
  /** It is a Picklist which specifies the type of Status. */
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<GraphQLSupporterType>;
};

export type GraphQLSupporterAddress = {
  __typename?: 'SupporterAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  invalid?: Maybe<Scalars['Boolean']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
};

export type GraphQLSupporterNames = {
  __typename?: 'SupporterNames';
  given?: Maybe<Scalars['String']['output']>;
  preferred?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type GraphQLSupporterPaymentMethod = {
  __typename?: 'SupporterPaymentMethod';
  accountNickname?: Maybe<Scalars['String']['output']>;
  ach?: Maybe<GraphQLPaymentMethodAch>;
  billingAddress?: Maybe<GraphQLPaymentMethodBillingAddress>;
  creditCard?: Maybe<GraphQLPaymentMethodCreditCard>;
  id?: Maybe<Scalars['String']['output']>;
  isCreatedForReceiptor?: Maybe<Scalars['Boolean']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  isSavedForReuse?: Maybe<Scalars['Boolean']['output']>;
  paymentType?: Maybe<Scalars['String']['output']>;
  sourceCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type GraphQLSupporterSpecialHandling = {
  __typename?: 'SupporterSpecialHandling';
  correspondenceDeliveryPreference?: Maybe<Scalars['String']['output']>;
};

export type GraphQLSupporterType = {
  __typename?: 'SupporterType';
  /** The supporter level 1 Account Type. */
  level1?: Maybe<Scalars['String']['output']>;
  /** The supporter level 2 Account Type. */
  level2?: Maybe<Scalars['String']['output']>;
  /** The supporter level 3 Account Type. */
  level3?: Maybe<Scalars['String']['output']>;
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;



/** Mapping between all available schema types and the resolvers types */
export type GraphQLResolversTypes = {
  AWSDate: ResolverTypeWrapper<Scalars['AWSDate']['output']>;
  AWSDateTime: ResolverTypeWrapper<Scalars['AWSDateTime']['output']>;
  AWSEmail: ResolverTypeWrapper<Scalars['AWSEmail']['output']>;
  AWSIPAddress: ResolverTypeWrapper<Scalars['AWSIPAddress']['output']>;
  AWSJSON: ResolverTypeWrapper<Scalars['AWSJSON']['output']>;
  AWSPhone: ResolverTypeWrapper<Scalars['AWSPhone']['output']>;
  AWSTime: ResolverTypeWrapper<Scalars['AWSTime']['output']>;
  AWSTimestamp: ResolverTypeWrapper<Scalars['AWSTimestamp']['output']>;
  AWSURL: ResolverTypeWrapper<Scalars['AWSURL']['output']>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  CardExpiryStatus: GraphQLCardExpiryStatus;
  Commitment: ResolverTypeWrapper<GraphQLCommitment>;
  CommitmentDates: ResolverTypeWrapper<GraphQLCommitmentDates>;
  CommitmentFund: ResolverTypeWrapper<GraphQLCommitmentFund>;
  CommitmentParticipant: ResolverTypeWrapper<GraphQLCommitmentParticipant>;
  CommitmentParticipantNames: ResolverTypeWrapper<GraphQLCommitmentParticipantNames>;
  CommitmentSys: ResolverTypeWrapper<GraphQLCommitmentSys>;
  CommitmentType: GraphQLCommitmentType;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  GivingTotals: ResolverTypeWrapper<GraphQLGivingTotals>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  PaymentMethodAch: ResolverTypeWrapper<GraphQLPaymentMethodAch>;
  PaymentMethodBillingAddress: ResolverTypeWrapper<GraphQLPaymentMethodBillingAddress>;
  PaymentMethodCreditCard: ResolverTypeWrapper<GraphQLPaymentMethodCreditCard>;
  Query: ResolverTypeWrapper<{}>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  Supporter: ResolverTypeWrapper<GraphQLSupporter>;
  SupporterAddress: ResolverTypeWrapper<GraphQLSupporterAddress>;
  SupporterNames: ResolverTypeWrapper<GraphQLSupporterNames>;
  SupporterPaymentMethod: ResolverTypeWrapper<GraphQLSupporterPaymentMethod>;
  SupporterSpecialHandling: ResolverTypeWrapper<GraphQLSupporterSpecialHandling>;
  SupporterType: ResolverTypeWrapper<GraphQLSupporterType>;
};

/** Mapping between all available schema types and the resolvers parents */
export type GraphQLResolversParentTypes = {
  AWSDate: Scalars['AWSDate']['output'];
  AWSDateTime: Scalars['AWSDateTime']['output'];
  AWSEmail: Scalars['AWSEmail']['output'];
  AWSIPAddress: Scalars['AWSIPAddress']['output'];
  AWSJSON: Scalars['AWSJSON']['output'];
  AWSPhone: Scalars['AWSPhone']['output'];
  AWSTime: Scalars['AWSTime']['output'];
  AWSTimestamp: Scalars['AWSTimestamp']['output'];
  AWSURL: Scalars['AWSURL']['output'];
  Boolean: Scalars['Boolean']['output'];
  Commitment: GraphQLCommitment;
  CommitmentDates: GraphQLCommitmentDates;
  CommitmentFund: GraphQLCommitmentFund;
  CommitmentParticipant: GraphQLCommitmentParticipant;
  CommitmentParticipantNames: GraphQLCommitmentParticipantNames;
  CommitmentSys: GraphQLCommitmentSys;
  Float: Scalars['Float']['output'];
  GivingTotals: GraphQLGivingTotals;
  ID: Scalars['ID']['output'];
  PaymentMethodAch: GraphQLPaymentMethodAch;
  PaymentMethodBillingAddress: GraphQLPaymentMethodBillingAddress;
  PaymentMethodCreditCard: GraphQLPaymentMethodCreditCard;
  Query: {};
  String: Scalars['String']['output'];
  Supporter: GraphQLSupporter;
  SupporterAddress: GraphQLSupporterAddress;
  SupporterNames: GraphQLSupporterNames;
  SupporterPaymentMethod: GraphQLSupporterPaymentMethod;
  SupporterSpecialHandling: GraphQLSupporterSpecialHandling;
  SupporterType: GraphQLSupporterType;
};

export interface GraphQLAwsDateScalarConfig extends GraphQLScalarTypeConfig<GraphQLResolversTypes['AWSDate'], any> {
  name: 'AWSDate';
}

export interface GraphQLAwsDateTimeScalarConfig extends GraphQLScalarTypeConfig<GraphQLResolversTypes['AWSDateTime'], any> {
  name: 'AWSDateTime';
}

export interface GraphQLAwsEmailScalarConfig extends GraphQLScalarTypeConfig<GraphQLResolversTypes['AWSEmail'], any> {
  name: 'AWSEmail';
}

export interface GraphQLAwsipAddressScalarConfig extends GraphQLScalarTypeConfig<GraphQLResolversTypes['AWSIPAddress'], any> {
  name: 'AWSIPAddress';
}

export interface GraphQLAwsjsonScalarConfig extends GraphQLScalarTypeConfig<GraphQLResolversTypes['AWSJSON'], any> {
  name: 'AWSJSON';
}

export interface GraphQLAwsPhoneScalarConfig extends GraphQLScalarTypeConfig<GraphQLResolversTypes['AWSPhone'], any> {
  name: 'AWSPhone';
}

export interface GraphQLAwsTimeScalarConfig extends GraphQLScalarTypeConfig<GraphQLResolversTypes['AWSTime'], any> {
  name: 'AWSTime';
}

export interface GraphQLAwsTimestampScalarConfig extends GraphQLScalarTypeConfig<GraphQLResolversTypes['AWSTimestamp'], any> {
  name: 'AWSTimestamp';
}

export interface GraphQLAwsurlScalarConfig extends GraphQLScalarTypeConfig<GraphQLResolversTypes['AWSURL'], any> {
  name: 'AWSURL';
}

export type GraphQLCommitmentResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['Commitment'] = GraphQLResolversParentTypes['Commitment']> = {
  _sys?: Resolver<Maybe<GraphQLResolversTypes['CommitmentSys']>, ParentType, ContextType>;
  commitmentType?: Resolver<Maybe<GraphQLResolversTypes['CommitmentType']>, ParentType, ContextType>;
  dates?: Resolver<Maybe<GraphQLResolversTypes['CommitmentDates']>, ParentType, ContextType>;
  fund?: Resolver<Maybe<GraphQLResolversTypes['CommitmentFund']>, ParentType, ContextType>;
  hasMissedPayment?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<GraphQLResolversTypes['ID'], ParentType, ContextType>;
  internalId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  interventionId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  isCorrespondent?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  isRecurring?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  lastCorrespondenceDate?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  participant?: Resolver<Maybe<GraphQLResolversTypes['CommitmentParticipant']>, ParentType, ContextType>;
  paymentDateLast?: Resolver<Maybe<GraphQLResolversTypes['AWSDate']>, ParentType, ContextType>;
  paymentDateNext?: Resolver<Maybe<GraphQLResolversTypes['AWSDate']>, ParentType, ContextType>;
  paymentFrequency?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  paymentMethodId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  paymentPullDay?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  rate?: Resolver<Maybe<GraphQLResolversTypes['Float']>, ParentType, ContextType>;
  receiptorId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  sourceCode?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  transactionId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLCommitmentDatesResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['CommitmentDates'] = GraphQLResolversParentTypes['CommitmentDates']> = {
  end?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  start?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLCommitmentFundResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['CommitmentFund'] = GraphQLResolversParentTypes['CommitmentFund']> = {
  code?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  icon?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLCommitmentParticipantResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['CommitmentParticipant'] = GraphQLResolversParentTypes['CommitmentParticipant']> = {
  birthdate?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  gender?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  globalId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  localId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  names?: Resolver<Maybe<GraphQLResolversTypes['CommitmentParticipantNames']>, ParentType, ContextType>;
  photoUrl?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLCommitmentParticipantNamesResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['CommitmentParticipantNames'] = GraphQLResolversParentTypes['CommitmentParticipantNames']> = {
  preferred?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLCommitmentSysResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['CommitmentSys'] = GraphQLResolversParentTypes['CommitmentSys']> = {
  billingType?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  delinkType?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  linkType?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  program?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  recordType?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  subProgram?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLGivingTotalsResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['GivingTotals'] = GraphQLResolversParentTypes['GivingTotals']> = {
  amountDue?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  amountWaived?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  annual?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  creditRemaining?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  monthly?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  quarterly?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  semiAnnual?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLPaymentMethodAchResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['PaymentMethodAch'] = GraphQLResolversParentTypes['PaymentMethodAch']> = {
  accountName?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  lastFourOfAccountNumber?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  routingNumber?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  token?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLPaymentMethodBillingAddressResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['PaymentMethodBillingAddress'] = GraphQLResolversParentTypes['PaymentMethodBillingAddress']> = {
  attention?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  stateCode?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLPaymentMethodCreditCardResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['PaymentMethodCreditCard'] = GraphQLResolversParentTypes['PaymentMethodCreditCard']> = {
  cardType?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  cardholderName?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  digitalType?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  expirationDate?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  expiryStatus?: Resolver<Maybe<GraphQLResolversTypes['CardExpiryStatus']>, ParentType, ContextType>;
  lastFour?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  responseCode?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  token?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLQueryResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['Query'] = GraphQLResolversParentTypes['Query']> = {
  supporter?: Resolver<Maybe<GraphQLResolversTypes['Supporter']>, ParentType, ContextType, Partial<GraphQLQuerySupporterArgs>>;
};

export type GraphQLSupporterResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['Supporter'] = GraphQLResolversParentTypes['Supporter']> = {
  address?: Resolver<Maybe<GraphQLResolversTypes['SupporterAddress']>, ParentType, ContextType>;
  commitments?: Resolver<Maybe<Array<Maybe<GraphQLResolversTypes['Commitment']>>>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  givingTotals?: Resolver<Maybe<GraphQLResolversTypes['GivingTotals']>, ParentType, ContextType>;
  globalId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  internalId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  isGroup?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  language?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  names?: Resolver<Maybe<GraphQLResolversTypes['SupporterNames']>, ParentType, ContextType>;
  organization?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  paymentMethods?: Resolver<Maybe<Array<Maybe<GraphQLResolversTypes['SupporterPaymentMethod']>>>, ParentType, ContextType>;
  primaryContactId?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  specialHandling?: Resolver<Maybe<GraphQLResolversTypes['SupporterSpecialHandling']>, ParentType, ContextType>;
  status?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<GraphQLResolversTypes['SupporterType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLSupporterAddressResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['SupporterAddress'] = GraphQLResolversParentTypes['SupporterAddress']> = {
  city?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  invalid?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  street2?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLSupporterNamesResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['SupporterNames'] = GraphQLResolversParentTypes['SupporterNames']> = {
  given?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  preferred?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  prefix?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  suffix?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  surname?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLSupporterPaymentMethodResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['SupporterPaymentMethod'] = GraphQLResolversParentTypes['SupporterPaymentMethod']> = {
  accountNickname?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  ach?: Resolver<Maybe<GraphQLResolversTypes['PaymentMethodAch']>, ParentType, ContextType>;
  billingAddress?: Resolver<Maybe<GraphQLResolversTypes['PaymentMethodBillingAddress']>, ParentType, ContextType>;
  creditCard?: Resolver<Maybe<GraphQLResolversTypes['PaymentMethodCreditCard']>, ParentType, ContextType>;
  id?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  isCreatedForReceiptor?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  isPrimary?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  isSavedForReuse?: Resolver<Maybe<GraphQLResolversTypes['Boolean']>, ParentType, ContextType>;
  paymentType?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  sourceCode?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLSupporterSpecialHandlingResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['SupporterSpecialHandling'] = GraphQLResolversParentTypes['SupporterSpecialHandling']> = {
  correspondenceDeliveryPreference?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLSupporterTypeResolvers<ContextType = any, ParentType extends GraphQLResolversParentTypes['SupporterType'] = GraphQLResolversParentTypes['SupporterType']> = {
  level1?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  level2?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  level3?: Resolver<Maybe<GraphQLResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GraphQLResolvers<ContextType = any> = {
  AWSDate?: GraphQLScalarType;
  AWSDateTime?: GraphQLScalarType;
  AWSEmail?: GraphQLScalarType;
  AWSIPAddress?: GraphQLScalarType;
  AWSJSON?: GraphQLScalarType;
  AWSPhone?: GraphQLScalarType;
  AWSTime?: GraphQLScalarType;
  AWSTimestamp?: GraphQLScalarType;
  AWSURL?: GraphQLScalarType;
  Commitment?: GraphQLCommitmentResolvers<ContextType>;
  CommitmentDates?: GraphQLCommitmentDatesResolvers<ContextType>;
  CommitmentFund?: GraphQLCommitmentFundResolvers<ContextType>;
  CommitmentParticipant?: GraphQLCommitmentParticipantResolvers<ContextType>;
  CommitmentParticipantNames?: GraphQLCommitmentParticipantNamesResolvers<ContextType>;
  CommitmentSys?: GraphQLCommitmentSysResolvers<ContextType>;
  GivingTotals?: GraphQLGivingTotalsResolvers<ContextType>;
  PaymentMethodAch?: GraphQLPaymentMethodAchResolvers<ContextType>;
  PaymentMethodBillingAddress?: GraphQLPaymentMethodBillingAddressResolvers<ContextType>;
  PaymentMethodCreditCard?: GraphQLPaymentMethodCreditCardResolvers<ContextType>;
  Query?: GraphQLQueryResolvers<ContextType>;
  Supporter?: GraphQLSupporterResolvers<ContextType>;
  SupporterAddress?: GraphQLSupporterAddressResolvers<ContextType>;
  SupporterNames?: GraphQLSupporterNamesResolvers<ContextType>;
  SupporterPaymentMethod?: GraphQLSupporterPaymentMethodResolvers<ContextType>;
  SupporterSpecialHandling?: GraphQLSupporterSpecialHandlingResolvers<ContextType>;
  SupporterType?: GraphQLSupporterTypeResolvers<ContextType>;
};

